import type { PlanTier } from '@frameio/graphql-client/generated';
import { useGetPlansQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { EMPTY_ARRAY } from '@frameio/utils';
import { ENTERPRISE_PLAN } from '../constants';

export const TIER_MAP: { [key in PlanTier]: string } = {
  FREE: 'PRO',
  PRO: 'TEAM',
  TEAM: 'ENTERPRISE',
  ENTERPRISE: 'ENTERPRISE',
  BUSINESS: '',
  STARTER: '',
};

export const useNextTierPlan = ({
  period = '',
  tier = '' as PlanTier,
}: {
  period?: string;
  tier?: PlanTier;
}) => {
  const accountId = useActiveAccountId();
  const { data: plansData } = useGetPlansQuery({
    variables: { accountId: accountId ?? '' },
    skip: !accountId,
  });

  const plans = plansData?.account?.plans ?? EMPTY_ARRAY;
  const nextTier = TIER_MAP[tier];
  const nextPlan = plans.find(
    (plan) => plan.tier === nextTier && plan.period === period
  );

  return nextPlan || ENTERPRISE_PLAN;
};
